import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { FAQ } from "@/shared/resource/apis/endpoints";

export const useFaqStore = defineStore("faq", {
  state: () => ({
    entities: [],
    totalEntities: 0,
  }),

  actions: {
    async addFAQ(payload) {
      const response = await api.post(FAQ.POST, payload);
      return response.data;
    },
    clearEntities() {
      this.entities = [];
      this.totalEntities = 0;
    },

    async fetch({ page = 1, limit = 10 }) {
      this.clearEntities();
      const response = await api.get(FAQ.GET, {
        params: { page_no: page, limit },
      });
      const data = response?.data?.data || [];

      const formattedEntities = data.map((faq) => ({
        faqId: faq.faq_id,
        question: faq.faq_title,
        type: faq.faq_cat1,
        category: faq.faq_cat,
        answer: faq.faq_ans,
      }));

      this.setEntities(formattedEntities, response?.data?.total_entries || 0);
      return formattedEntities;
    },

    async save(id, payload) {
      let response;
      if (id) {
        response = await this.addFAQ(payload);
      } else {
        response = await this.updateFAQ(id, payload);
      }
      return response;
    },

    setEntities(entities, totalEntities) {
      this.entities = entities;
      this.totalEntities = totalEntities;
    },

    async updateFAQ(id, payload) {
      const response = await api.put(FAQ.PUT(id), payload);
      return response.data;
    },
  },

  getters: {
    getEntities: (state) => state.entities,
    getTotalEntities: (state) => state.totalEntities,
  },
});
